import axios from "axios";
import config from "../config";

const GoogleService = {
  getGeocode(address) {
    return axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(
        address
      )}&key=${config("GOOGLE_API_KEY")}`
    );
  }
};

export default GoogleService;
